
import React from 'react';
import { Button, Row, Col } from "reactstrap";	// reactstrap components
import { InputGroup, InputGroupText, Input } from "reactstrap";	// reactstrap components
import * as utility from 'components/Utils';


export default class Control extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			content: " ",
			password: "",
			msgWarning: null,
			isAuthorized: localStorage.getItem('isAuthorized'),
			thermostatSetting: [],
			temperatures: { "Office": 0, "exterior": 0, "downstairs": 0, "livingroom": 0 },
		};

		this.handleAuthorizationPassword = this.handleAuthorizationPassword.bind(this);
		this.setThermostatSetting = this.setThermostatSetting.bind(this);
		this.getThermostatSetting = this.getThermostatSetting.bind(this);
		this.showThermostatValues = this.showThermostatValues.bind(this);
	}

	componentDidMount() {
		this.getTemperatures();
		this.getThermostatSetting();
		this.intervalGetThermostat = setInterval(() => this.getThermostatSetting(), 60*1000);	// every 60 seconds update the thermostat value
		this.intervalTemperature = setInterval(() => this.getTemperatures(), 60*1000);	// every 60 seconds update the temperature values
	}

	componentWillUnmount() {
		clearInterval(this.intervalGetThermostat);
		clearInterval(this.intervalTemperature);
	}

	getTemperatures() {
		const url = utility.getRootUrl()+'/getTemperatures.php';

		fetch(url)
			.then(function (response) {
				// console.log(url + " -> " + response.ok);
				return response.json();
			})
			.then(function (data) {
				// console.log("data: "); console.dir(data);
				let theTemperatures = data.temperatures;
				theTemperatures["avgIndoors"] = (theTemperatures["Office"] + theTemperatures["downstairs"] + theTemperatures["livingroom"] + theTemperatures["entryway"]) / 4;
				this.setState({ temperatures: theTemperatures });
			}.bind(this))
			.catch(function (err) {
				console.log("failed to load ", url, err.stack);
			});
	}


	setThermostatSetting() {
		console.log( `setThermostatSetting()  Set Thermostat Setting to ${this.state.thermostatSetting.join(" .. ")} ` );
		clearInterval(this.intervalSetThermostat);

		/* send thermostat settings */
		let thermoFurnace = this.state.thermostatSetting[0];
		let thermoAC = this.state.thermostatSetting[1];
		utility.sendMQTT( 'thermostat', 'set-temperature-furnace', thermoFurnace, this );
		utility.sendMQTT( 'thermostat', 'set-temperature-ac', thermoAC, this );

		this.intervalGetThermostat = setInterval(() => this.getThermostatSetting(), 60*1000);	// every 60 seconds update the thermostat value
	}

	getThermostatSetting() {
		const url = utility.getRootUrl()+'/getThermostatSetting.php';

		fetch(url)
			.then(function (response) {
				// console.log(url + " -> " + response.ok);
				return response.json();
			})
			.then(function (data) {
				// console.log("data: "); console.dir(data);
				this.setState({ thermostatSetting: data.thermostat_setting, thermostat_state: data.thermostat_state });
			}.bind(this))
			.catch(function (err) {
				console.log("failed to load ", url, err.stack);
			});
	}

	showThermostatValues( values ) {
		this.setState({ thermostatSetting: values });
	}

	handleAuthorizationPassword( event ) {
		event.preventDefault();

		if ( this.state.password === '00' ) {
			this.setState( { isAuthorized: true } );
			localStorage.setItem('isAuthorized', true );
		}
	}

	handleThermostatChangeClick( which, desiredChange ) {
		console.log( `handleThermostatChangeClick( ${which}, ${desiredChange} ) ` );

		var thermoFurnace = this.state.thermostatSetting[0];
		var thermoAC = this.state.thermostatSetting[1];
		var tempOutside = parseInt(this.state.temperatures["exterior"] + 0.5,10);
		var tempDownstairs = parseInt(this.state.temperatures["downstairs"] + 0.5,10);

		if ( which === "ac" ) {
			if ( desiredChange === "hotter" ) {
				thermoAC += 1;
				if ( thermoAC >= tempDownstairs ) {
					this.setState( { msgWarning: null } );
				}
			} else {
				thermoAC -= 1;
				if ( (thermoAC > tempOutside) && (thermoAC < tempDownstairs) ) {
					this.setState( { msgWarning: "Outside temperature is colder than this A/C setting" } );
				}
			}
		}

		if ( which === "furnace" ) {
			if ( desiredChange === "hotter" ) {
				thermoFurnace += 1;
				if ( (thermoFurnace < tempOutside) && (thermoFurnace > tempDownstairs) ) {
					this.setState( { msgWarning: "Outside temperature is hotter than this furnace setting" } );
				}
			} else {
				thermoFurnace -= 1;
				if ( (thermoFurnace <= tempDownstairs) ) {
					this.setState( { msgWarning: null } );
				}
			}
		}

		this.showThermostatValues( [ thermoFurnace, thermoAC ] );

		clearInterval(this.intervalGetThermostat);
		clearInterval(this.intervalSetThermostat);
		this.intervalSetThermostat = setInterval(() => this.setThermostatSetting(), 3*1000);	// in 3 seconds update the thermostat with these values
	}


	showWarning( msg ) {
		if ( msg && (msg.length <= 0) ) {
			return null;
		}

		clearInterval(this.intervalClearWarning);
		this.intervalClearWarning = setInterval(() => this.clearWarning(), 9*1000);	// in 9 seconds clear this warning

		return (
			<div>
				<br />
				<Row>
					<Col className="font16" style={{color: "red"}}> { msg } </Col>
				</Row>
			</div>
		);
	}

	clearWarning() {
		this.setState( { msgWarning: null } );
		clearInterval(this.intervalClearWarning);
	}

	setPassword(val) {
		this.setState( { password: val } );
	}


	loginFirst() {
		return (
			<div className="Login">
			  <form onSubmit={this.handleAuthorizationPassword}>
				<InputGroup name="password">
				  <InputGroupText> Unlock Code </InputGroupText>
				  <Input
					value={this.state.password}
					onChange={e => this.setPassword(e.target.value)}
				  />
				</InputGroup>
				<Button block type="submit">
				  Login
				</Button>
			  </form>
			</div>
		);

	}

    render() {

		if ( ! this.state.isAuthorized ) {
			return (
			<div className="content"
				style={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
				}}>
				{this.loginFirst()}
			</div>
			);
		}

		return (
			<div className="content numbers">

				<Row>
					<Col lg="2" sm="5" xs="7"> Average Indoors </Col>
					<Col className="font16 "> { parseInt(this.state.temperatures["avgIndoors"] + 0.5,10) } </Col>
				</Row>
				<Row>
					<Col lg="2" sm="5" xs="7"> Downstairs Kitchen </Col>
					<Col className="font16 downstairs-temperature"> { parseInt(this.state.temperatures["downstairs"] + 0.5,10) } </Col>
				</Row>
				<Row>
					<Col lg="2" sm="5" xs="7"> Office </Col>
					<Col className="font16 office-temperature"> { parseInt(this.state.temperatures["Office"] + 0.5,10) } </Col>
				</Row>
				<Row>
					<Col lg="2" sm="5" xs="7"> Upstairs Living Room </Col>
					<Col className="font16 livingroom-temperature"> { parseInt(this.state.temperatures["livingroom"] + 0.5,10) } </Col>
				</Row>
				<Row>
					<Col lg="2" sm="5" xs="7"> Upstairs Entryway </Col>
					<Col className="font16 livingroom-temperature"> { parseInt(this.state.temperatures["entryway"] + 0.5,10) } </Col>
				</Row>
				<Row>
					<Col lg="2" sm="5" xs="7"> Outside Under Stairs </Col>
					<Col className="font16 exterior-temperature"> { parseInt(this.state.temperatures["exterior"] + 0.5,10) } </Col>
				</Row>
				<br />

				<hr />

				<Row>
					<Col lg="2" sm="5" xs="7">
						Thermostat Setting:
					</Col>
					<Col>
						<div id='info-thermostat'> {this.state.thermostatSetting && this.state.thermostatSetting.join(" .. ")} </div>
					</Col>
				</Row>

				<Row>
					<Col lg="2" sm="5" xs="7">
						Status Currently:
					</Col>
					<Col>
						<div id='info-thermostat'> {this.state.thermostat_state} </div>
					</Col>
				</Row>

				{ this.showWarning( this.state.msgWarning ) }

				<br />
				<Row>
					<Col>
						<Button style={{ backgroundColor: "blue" }} onClick={() => { this.handleThermostatChangeClick("ac","colder"); } }> Make A/C <font size="+1">More</font> Cold </Button>
						<Button style={{ backgroundColor: "blue" }} onClick={() => { this.handleThermostatChangeClick("ac","hotter"); } }> Make A/C <font size="+1">Less</font> Cold </Button>
					</Col>
				</Row>

				<br />
				<Row>
					<Col>
						<Button style={{ backgroundColor: "red" }} onClick={() => { this.handleThermostatChangeClick("furnace","hotter"); } }> Make Furnace <font size="+1">More</font> Hot </Button>
						<Button style={{ backgroundColor: "red" }} onClick={() => { this.handleThermostatChangeClick("furnace","colder"); } }> Make Furnace <font size="+1">Less</font> Hot </Button>
					</Col>
				</Row>

			</div>
		);
    }
}
